import * as moment from 'moment';
import { PeriodType } from '../enums/period-type.enum';
import { ReservationConfigType } from '../enums/reservation-config-type.enum';
import { ReservationFeeType } from '../enums/reservation-fee-type.enum';
import { ReservationType } from '../enums/reservation-type.enum';

export class ReservationConfig {
  id?: number;
  storeId: number;
  timeInAdvance: number;
  advancePeriod: string;
  delayTolerance: number;
  automaticallyApprove: boolean;
  minApprovalLimit: number;
  approvalLimit: number;
  minSeatLimit: number;
  reservationType: ReservationType;
  manualIfLimitOver: boolean;
  minimumAdvanceTime: number;
  status?: string;
  feeType: ReservationFeeType;
  paymentRequired: boolean;
  description: string;
  descriptionFee: string;
  periodType: PeriodType;
  periodInterval: number | string;
  selfService: boolean;
  configType: ReservationConfigType;

  // Special Date
  name: string;
  specialDate: string;

  // Aux view
  titlePage: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.approvalLimit == null) {
      this.approvalLimit = 0;
    }
    if (this.minApprovalLimit == null) {
      this.minApprovalLimit = 0;
    }
    if (this.minSeatLimit == null) {
      this.minSeatLimit = 0;
    }
    if (!this.configType) {
      this.configType = ReservationConfigType.DEFAULT;
    }
    if (!this.reservationType) {
      this.reservationType = ReservationType.TABLE;
    }
    if (!this.periodType) {
      this.periodType = PeriodType.PERIOD;
      this.periodInterval = 30;
    }
    // Por mesa, sempre é cobrado o valor da mesa.
    if (!this.feeType || this.reservationType == ReservationType.TABLE) {
      this.feeType = ReservationFeeType.TRANSACTION;
    }
    // Demais campos default para nova config
    if (!this.id) {
      this.status = 'DRAFT';
      this.delayTolerance = 15;
      this.manualIfLimitOver = false;
      this.minimumAdvanceTime = 1;
      this.selfService = true;
    }

    if (this.configType == ReservationConfigType.DEFAULT) {
      this.titlePage = 'RESERVATION.CONFIG_TITLE';
    } else {
      const dateName: string = this.name || 'Data especial';
      this.titlePage = this.specialDate
        ? `${dateName} (${moment(this.specialDate).format('DD/MM/YYYY')})`
        : 'RESERVATION.CONFIG_SPECIAL_DATE_TITLE';
    }
  }

  toJson(): any {
    const isTable: boolean = this.reservationType == ReservationType.TABLE;
    if (isTable) {
      this.feeType = ReservationFeeType.TRANSACTION;
    }
    // Os limites de lugares por reserva são exclusivos do tipo PEOPLE, e o limite de lugares a
    // menos por mesa é exclusivo do tipo TABLE. Zera o que não pertence ao tipo atual para não
    // deixar valor residual salvo quando a loja troca o tipo da reserva.
    const data: any = {
      id: this.id || null,
      storeId: this.storeId,
      timeInAdvance: Number(this.timeInAdvance),
      advancePeriod: this.advancePeriod,
      delayTolerance: this.delayTolerance,
      automaticallyApprove: this.automaticallyApprove,
      approvalLimit: isTable ? 0 : this.approvalLimit || 0,
      reservationType: this.reservationType || ReservationType.PEOPLE,
      manualIfLimitOver: isTable ? false : this.manualIfLimitOver,
      minimumAdvanceTime: this.minimumAdvanceTime || 0,
      minSeatLimit: isTable ? this.minSeatLimit || 0 : 0,
      status: this.status || null,
      feeType: this.feeType,
      paymentRequired: this.paymentRequired,
      description: this.description,
      descriptionFee: this.descriptionFee,
      periodType: this.periodType,
      periodInterval: this.periodInterval,
      selfService: this.selfService,
      configType: this.configType,
      minApprovalLimit: isTable ? 0 : this.minApprovalLimit,
    };
    if (this.configType == ReservationConfigType.SPECIAL_DATE) {
      data.name = this.name;
      data.specialDate = this.specialDate;
    }
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/reservation/models/reservation-config.model.ts